import React, { FC, useEffect, useState } from "react";
import {
  Modal,
  Form,
  Select,
  Alert,
  message,
  FormInstance,
  Input,
  Space,
  DatePicker,
  Button,
  UploadFile,
} from "antd";
import styled from "@emotion/styled";
import UploadImages from "components/UploadImages";
import {
  ConfirmManualPaymentInput,
  GetDataOrderListItems,
  GetOrderDetailBankpayment,
  GetOrderDetailData,
} from "services/interface";
import { backendUrl } from "config";
import { useConfirmManualPayment } from "hooks/useOrders";
import dayjs from "dayjs";
import { setLoading } from "store/slices/loadingSlice";
import { useAppDispatch } from "store";
import { formatYearMonthDateWithTime } from "utils/dateFormat";
import { InputRef } from "antd";

interface ConfirmPaymentDialogProps {
  order_id: string;
  form: FormInstance;
  item: GetOrderDetailBankpayment | undefined;
  onClose: () => void;
  childrenBank: React.ReactNode[];
  refetchData: () => void;
  refetchPrepare?: () => void;
  fromAgent?: false;
  formValues: any;
  index: string;
  onRemove: () => void;
  inputRef?: (el: InputRef | null) => void;
}

const ConfirmPaymentDetail: FC<ConfirmPaymentDialogProps> = ({
  order_id,
  form,
  item,
  onClose,
  childrenBank,
  refetchData,
  refetchPrepare,
  fromAgent,
  formValues,
  index,
  onRemove,
  inputRef,
}) => {
  const { mutate: confirmManualPayment } = useConfirmManualPayment();
  const dispatch = useAppDispatch();
  const [paymentDate, setPaymentDate] = useState<Date | null>(null);

  useEffect(() => {
    if (index === item?.id) {
      form.setFieldsValue({
        [`bank_id[${index}]`]: item.bank_id,
        // `payment_date[${index}]`: item.payment_date,
        [`payment_amount[${index}]`]: item.pay_amount || 0,
        [`image_slip[${index}]`]: item.image_slip
          ? [
              {
                uid: "-1",
                name: "images.png",
                status: "done",
                id: "",
                url: item.image_slip,
              },
            ]
          : null,
      });

      // if (item.pay_amount) {
      //   form.setFieldsValue({
      //     [`payment_amount[${index}]`]: item.pay_amount,
      //   })
      // }
      if (item.payment_date) {
        form.setFieldsValue({
          [`payment_date[${index}]`]: dayjs(item.payment_date) ?? undefined,
        });
      }
    }
  }, [item, form, index]);

  // const onConfirmPayment = (values: any ) => {
  //   // const imagesSlipList = values?.image_slip?.map((item: { url: string; }) => item.url);
  //   const confirmData:ConfirmManualPaymentInput = {
  //     order_id: order_id || '',
  //     payment_list: [
  //       {
  //         id: item?.id ?? '',
  //         bank_id: values.bank_id,
  //         image_slip: values?.image_slip ? `${backendUrl}images/${values.image_slip[0].id}` : '',
  //         amount: values?.payment_amount || 0,
  //         payment_date: paymentDate ? formatYearMonthDateWithTime(paymentDate) : undefined
  //       }
  //     ]
  //   }
  //   confirmManualPayment(confirmData, {
  //     onSuccess: (res) => {
  //       if (res.status === "success") {
  //         message.success(`ยืนยันการโอนเงินสำเร็จ`);
  //         setPaymentDate(null);
  //         refetchData();
  //         onClose();
  //         form.resetFields();
  //         dispatch(setLoading(false));
  //         refetchPrepare && refetchPrepare();
  //       } else {
  //         message.error(`ยืนยันการโอนเงินไม่สำเร็จ: ${res.error_message}`);
  //         dispatch(setLoading(false));
  //       }
  //     },
  //     onError: (error) => {
  //       message.error(`ยืนยันการโอนเงินไม่สำเร็จ: ${error.message}`);
  //       dispatch(setLoading(false));
  //     },
  //   });
  // }

  return (
    <div style={{ marginTop: "10px" }}>
      {/* <Form onFinish={onConfirmPayment}> */}
      <Form.Item
        label="บัญชีธนาคาร"
        name={`bank_id[${index}]`}
        rules={[{ required: true, message: "กรุณาเลือกบัญชีธนาคาร" }]}>
        <Select
          placeholder="กรุณาเลือกบัญชีธนาคาร"
          optionFilterProp="children"
          defaultValue={formValues[`bank_id_${index}`]}>
          {childrenBank}
        </Select>
      </Form.Item>
      <Form.Item
        label="ระบุวันและเวลาที่โอน"
        labelAlign="left"
        name={`payment_date[${index}]`}>
        <DatePicker
          showTime={{ format: "HH:mm" }}
          format="YYYY-MM-DD HH:mm"
          placeholder="ระบุวันและเวลาที่โอน"
          value={paymentDate ? dayjs(paymentDate) : null}
          defaultValue={
            !item?.payment_date && !formValues[`payment_date_${index}`]
              ? dayjs()
              : undefined
          }
          onChange={(date) => setPaymentDate(date ? date.toDate() : null)}
        />
      </Form.Item>
      <Form.Item
        labelAlign="left"
        label="ระบุจำนวนที่โอน"
        name={`payment_amount[${index}]`}
        rules={[
          {
            required: true,
            message: "ระบุจำนวนที่โอน",
          },
          {
            validator: (_, value) => {
              if (
                value === 0 ||
                value === "" ||
                value === undefined ||
                value === null
              ) {
                return Promise.reject("ระบุจำนวนที่โอน");
              }
              return Promise.resolve();
            },
          },
        ]}
        validateTrigger={["onBlur", "onSubmit"]}>
        <Input
          placeholder="ระบุจำนวนที่โอน"
          size="small"
          type="number"
          onFocus={(e) => {
            if (e.target.value === "0") {
              form.setFieldsValue({ [`payment_amount[${index}]`]: "" });
            }
          }}
          onBlur={(e) => {
            if (e.target.value === "" || e.target.value === null) {
              form.setFieldsValue({ [`payment_amount[${index}]`]: 0 });
            }
          }}
          ref={inputRef}
        />
      </Form.Item>

      <Form.Item label="แนบรูปภาพ" name={`image_slip[${index}]`}>
        <UploadImages maximumUploadItems={1} typeUpload="slip" />
      </Form.Item>

      {index.length <= 5 && (
        <Button onClick={onRemove} type="link" danger>
          <u>ลบทิ้ง</u>
        </Button>
      )}
      {/* </Form> */}
      <Divider />
    </div>
  );
};

export default ConfirmPaymentDetail;

const Divider = styled.div`
  border-bottom: 0.5px solid #e8e8e8;
  margin: 0px 0px 0px 0px;
`;
